import { StandaloneFrame as V32StandaloneFrame } from "@rosc/ui/v32/standalone-frame";
import type { JSX, ReactNode } from "react";
import { AppConfig } from "@/common/appConfig";
import { V3Logo } from "./logo";

/**
 * A page outside the app shell (404, the feedback page): the ROSC bar on
 * top and the content centred. In the v3.2 app (VITE_APP_REDESIGN_ENABLED)
 * @rosc/ui's StandaloneFrame (packages/ui/src/v32/standalone-frame.tsx);
 * the classic frame otherwise.
 */
export const StandaloneFrame = ({
  children,
  width = "md:w-[50%] lg:w-[40%] w-[80%]",
  align = "center",
}: {
  children: ReactNode;
  /** v3.2: text alignment inside the panel. */
  align?: "center" | "start";
  /** Classic content width. */
  width?: string;
}): JSX.Element =>
  AppConfig.enableAppRedesign ? (
    <V32StandaloneFrame align={align} logo={<V3Logo size={28} />}>
      {children}
    </V32StandaloneFrame>
  ) : (
    <div className="flex items-between flex-col size-full w-screen h-screen">
      <div className="flex justify-center border-b border-[#EEEEEE] border-solid p-4 bg-primary md:bg-white md:dark:bg-background">
        <h4 className="m-0 text-xl font-bold md:text-primary text-white">
          ROSC
        </h4>
      </div>
      <div className="flex flex-col justify-center items-center size-full">
        <div className={`text-center ${width}`}>{children}</div>
      </div>
    </div>
  );
